import { useContext } from 'react';

import G6Wrapper from 'dashboard/components/GraphCanvasV2/G6Wrapper';
import { G6WrapperContext } from 'dashboard/components/GraphModule/GraphCanvasContextProvider';

// In order for this hook to function, it must be preceded by a GraphContextWrapper
export function useG6Wrapper(g6WrapperRef?: React.MutableRefObject<G6Wrapper>) {
  const g6Wrapper = useContext(G6WrapperContext);

  if (g6WrapperRef) {
    g6WrapperRef.current = g6Wrapper;
  }

  return g6Wrapper;
}
